/**
 * React Query keys for admin error management
 */

export const adminErrorKeys = {
  all: ['admin', 'errors'] as const,
  lists: () => [...adminErrorKeys.all, 'list'] as const,
  list: (filters: Record<string, any>) => [...adminErrorKeys.lists(), filters] as const,
  stats: () => [...adminErrorKeys.all, 'stats'] as const,
  details: () => [...adminErrorKeys.all, 'detail'] as const,
  detail: (id: string) => [...adminErrorKeys.details(), id] as const,
};
